export enum CompanyActions {
  Toggled = 'toggled',
  PageChange = 'pageChange'
}
